'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002421 from "./presto.-Agent-View$$anon$21.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002423 from "./presto.-Agent-View$$anon$23.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dSign$002dFile$002dRequest$0024 from "./presto.-Agent-View$-Local-Pje-Office-Sign-File-Request$.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024 from "./presto.types$-U-R-L$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$20() {
  this.axS = null;
  this.axK = null;
  this.axL = false;
  this.axT = null;
  this.axU = false;
  this.axX = null;
  this.axQ = null;
  this.axR = false;
  this.axM = null;
  this.axN = false;
  this.axO = null;
  this.axP = false;
  this.axV = false;
  this.axW = false;
  this.axS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.axX = "LocalPjeOfficeSignFileRequest";
}
export { $c_Lpresto_AgentView$$anon$20 as $c_Lpresto_AgentView$$anon$20 };
$p = $c_Lpresto_AgentView$$anon$20.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$20;
/** @constructor */
function $h_Lpresto_AgentView$$anon$20() {
}
export { $h_Lpresto_AgentView$$anon$20 as $h_Lpresto_AgentView$$anon$20 };
$h_Lpresto_AgentView$$anon$20.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.axS;
});
$p.M = (function() {
  if ((!this.axL)) {
    this.axK = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.axL = true;
  }
  return this.axK;
});
$p.O = (function() {
  if ((!this.axU)) {
    this.axT = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.axU = true;
  }
  return this.axT;
});
$p.D = (function() {
  return this.axX;
});
$p.t = (function() {
  if ((!this.axR)) {
    this.axQ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("origin", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("algo", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("encoding", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("encapsulate", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("files", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.axR = true;
  }
  return this.axQ;
});
$p.N = (function() {
  if ((!this.axN)) {
    this.axM = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dU$002dR$002dL$0024.$m_Lpresto_types$URL$().fi(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aq, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002421.$c_Lpresto_AgentView$$anon$21())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.axN = true;
  }
  return this.axM;
});
$p.Q = (function() {
  if ((!this.axP)) {
    this.axO = new $j_presto$002e$002dAgent$002dView$0024$0024anon$002423.$c_Lpresto_AgentView$$anon$23();
    this.axP = true;
  }
  return this.axO;
});
$p.v = (function() {
  if ((!this.axW)) {
    this.axV = false;
    this.axW = true;
  }
  return this.axV;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee153) => ((p) => \u03b4scrutinee153.cGQ(p)))($j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dSign$002dFile$002dRequest$0024.$m_Lpresto_AgentView$LocalPjeOfficeSignFileRequest$())));
});
var $d_Lpresto_AgentView$$anon$20 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$20, "presto.AgentView$$anon$20", ({
  DP: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$20 as $d_Lpresto_AgentView$$anon$20 };
//# sourceMappingURL=presto.-Agent-View$$anon$20.js.map
